/** Тексты окна: ссылка для шаринга в обычном браузере. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.shareLink.copied": "Link copied",
  "win.shareLink.copiedText": "Paste it into any chat. Whoever opens it lands straight in the game.",
  "win.shareLink.title": "Share the game",
  "win.shareLink.text": "Copy the link and send it to a friend.",
  "win.shareLink.copy": "Copy",
  "win.shareLink.done": "Done",
  "win.shareLink.message": "I crushed {n} zombies in New Fun Game. Can you beat that?",
  "win.shareLink.messageNoKills": "Holding the line against zombies in New Fun Game. Join me!",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.shareLink.copied": "Ссылка скопирована",
  "win.shareLink.copiedText": "Вставь её в любой чат. Кто откроет, сразу попадёт в игру.",
  "win.shareLink.title": "Поделиться игрой",
  "win.shareLink.text": "Скопируй ссылку и отправь другу.",
  "win.shareLink.copy": "Скопировать",
  "win.shareLink.done": "Готово",
  "win.shareLink.message": "Я раздавил {n} зомби в New Fun Game. Сможешь больше?",
  "win.shareLink.messageNoKills": "Держу оборону от зомби в New Fun Game. Заходи!",
};

const uk: Record<Key, string> = {
  "win.shareLink.copied": "Посилання скопійовано",
  "win.shareLink.copiedText": "Встав його в будь-який чат. Хто відкриє, одразу потрапить у гру.",
  "win.shareLink.title": "Поділитися грою",
  "win.shareLink.text": "Скопіюй посилання й надішли другові.",
  "win.shareLink.copy": "Скопіювати",
  "win.shareLink.done": "Готово",
  "win.shareLink.message": "Я розчавив {n} зомбі в New Fun Game. Зможеш більше?",
  "win.shareLink.messageNoKills": "Тримаю оборону від зомбі в New Fun Game. Заходь!",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
